var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useForm } from "react-hook-form";
import React from "react";
import { Translate as T } from "react-localize-redux";
import { useKushkiJsContext } from "../../../../context/useKushkiJsContext";
import { useCheckoutContext } from "../../../../context/useCheckoutContext";
import { configCardSections } from "../../../../shared/constants/CheckoutContants";
export var useKpayEmailState = function () {
    var form = useForm({
        defaultValues: {
            email: "",
        },
        mode: "onBlur",
        reValidateMode: "onBlur",
    });
    var requestSavedPaymentMethods = useKushkiJsContext().requestSavedPaymentMethods;
    var _a = useCheckoutContext().handlers, setCheckoutSection = _a.setCheckoutSection, setEmailKpay = _a.setEmailKpay, setPaymentMethodsKpay = _a.setPaymentMethodsKpay, setCheckoutLoading = _a.setCheckoutLoading;
    var handleSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var requestBody, paymentMethodKpay, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        email: data.email,
                    };
                    setCheckoutLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, requestSavedPaymentMethods(requestBody)];
                case 2:
                    paymentMethodKpay = _a.sent();
                    if (paymentMethodKpay.length > 0) {
                        setEmailKpay(requestBody.email);
                        setPaymentMethodsKpay(paymentMethodKpay);
                        setCheckoutSection(configCardSections.kpayPaymentSelect);
                    }
                    else
                        setCheckoutSection(configCardSections.kpayEmptyPayment);
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    setCheckoutSection(configCardSections.kpayEmptyPayment);
                    return [3 /*break*/, 5];
                case 4:
                    setCheckoutLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var setRulesEmail = function () {
        var rules = {
            pattern: {
                message: React.createElement(T, { id: "kpayEmail.invalidEmail" }),
                value: new RegExp("^[\\w-.]+@([\\w-]+\\.)+[\\w-]+$"),
            },
            required: {
                message: React.createElement(T, { id: "kpayEmail.invalidEmail" }),
                value: true,
            },
        };
        return __assign({}, rules);
    };
    return {
        form: form,
        handleSubmit: handleSubmit,
        setRulesEmail: setRulesEmail,
    };
};
